import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M31.96 11.27V25.3L37 23.95l2.49-.67-6.9 21.87-2.51-7.39-1.21-3.55-3.62.97-4.53 1.22V14.41l11.24-3.14Zm4-5.27-19.24 5.37v30.24l9.56-2.56L32.72 58l12.76-40.46-9.53 2.55L35.96 6Z"
      }
    )
  }
);
export {
  t as Electric
};
